import { Either } from "src/base/Either";
import {
  DataConnectRepository,
  IDataConnectRepository,
} from "../../data/repositories/dataConnectRepository";
import { ISyncSession } from "../../data/datasources/dataConnectRemoteDataSource";

export interface ICreateSyncSession {
  call(): Promise<Either<Error, ISyncSession>>;
}

export class CreateSyncSession implements ICreateSyncSession {
  repository: IDataConnectRepository;

  constructor(repository?: IDataConnectRepository) {
    this.repository = repository || new DataConnectRepository();
  }

  async call(): Promise<Either<Error, ISyncSession>> {
    return await this.repository.createSyncSession();
  }
}
